<template>
  <div>
    <el-row>
      <div style="margin: 30px; border-bottom: 1px solid #ccc; line-height: 50px">
        <h2>用户注册</h2>
      </div>
    </el-row>
    <el-row>
      <el-col :sm="18" :md="14" :lg="14" :xl="14">
        <el-form label-width="90px" :model="form" ref="formData">
          <el-form-item label="账号" prop="accountName" :rules="ruleAccountName">
            <el-input placeholder="" size="large" v-model="form.accountName"></el-input>
          </el-form-item>

          <el-form-item label="密码" prop="accountPwd" :rules="ruleAccountPwd">
            <el-input placeholder="" size="large" v-model="form.accountPwd" :show-password="true"></el-input>
          </el-form-item>

          <el-form-item label="重复密码" prop="accountPwd2" :rules="ruleAccountPwd2">
            <el-input placeholder="" size="large" v-model="form.accountPwd2" :show-password="true"></el-input>
          </el-form-item>

          <el-form-item
            label="姓名"
            prop="userName"
            :rules="[
              {
                required: true,
                min: 2,
                max: 20,
                message: '长度在 2 到 20 个字符',
                trigger: 'blur',
              },
            ]"
          >
            <el-input placeholder="" size="large" v-model="form.userName"></el-input>
          </el-form-item>

          <el-form-item label="手机号码" prop="phone" :rules="rulePhone">
            <el-input ref="phone" placeholder="" size="large" v-model="form.phone"></el-input>
          </el-form-item>

          <el-form-item label="短信验证码" prop="captchaCode">
            <el-row>
              <el-col :span="8">
                <div>
                  <el-input ref="captchaCode" oninput="if(value.length>4)value=value.slice(0,4)" placeholder="图形验证码" size="large" v-model="captchaCode"></el-input>
                </div>
              </el-col>

              <el-col :span="9">
                <el-image :src="'data:image/png;base64,' + captchaSrc" style="height: 40px" alt="单击刷新验证码" @click="loadCaptcha"></el-image>
              </el-col>
              <el-col :span="7">
                <div style="padding-left: 10px">
                  <ButtonCountDown style="width: 100%" ref="ButtonCountDown" type="primary" size="large" text="发送短信" count="60" :method="sendSMS"></ButtonCountDown>
                </div>
              </el-col>
            </el-row>
          </el-form-item>

          <el-form-item prop="smsCode" v-show="sendSMSed">
            <el-row>
              <el-col :span="8">
                <div>
                  <el-input ref="smsCode" oninput="if(value.length>4)value=value.slice(0,4)" placeholder="短信验证码" size="large" v-model="form.smsCode"></el-input>
                </div>
              </el-col>
              <el-col :span="16">
                <div style="margin-left: 15px">输入收到的4位数短信验证码</div>
              </el-col>
            </el-row>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" size="large" @click="submit()">立即注册</el-button>
          </el-form-item>
        </el-form>
      </el-col>

      <el-col :sm="4" :md="10" :lg="10" :xl="10"> </el-col>
    </el-row>

    <el-dialog title="提示" :visible.sync="dialogVisible" width="400px">
      <span>{{ dialogContent }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogClose">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import ButtonCountDown from "@/components/ButtonCountDown.vue"
import accountApi from "@/api/account"
import captchaApi from "@/api/captcha"

//import { validAccountPwd, validPhone } from "@/utils/valid";
import { validAccountName, validAccountPwd, validPhone } from "@/utils/valid"
export default {
  components: {
    ButtonCountDown,
  },
  data() {
    var validAccountNameFun = (rule, value, callback) => {
      if (!validAccountName(value)) {
        callback(new Error("长度在 6 到 20 个英文/下划线/数字，第一个字母不能是下划线和数字"))
      } else {
        accountApi.checkUsernameUnique(value).then((res) => {
          if (res.code == 0) {
            callback()
          } else if (res.code == 1) {
            callback("该账号已经被占用")
          } else if (res.code == 301) {
            callback(new Error(res.data[0].msg + "333"))
          }
        })
      }
    }

    var validAccountPwdFun = (rule, value, callback) => {
      if (!validAccountPwd(value)) {
        callback(new Error("长度在 6 到 20 个字符(必须包含数字/小写字母/大写字母)"))
      } else {
        callback()
      }
    }

    var validAccountPwd2Fun = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"))
      } else if (value !== this.form.accountPwd) {
        callback(new Error("两次输入密码不一致!"))
      } else {
        callback()
      }
    }

    var validPhoneFun = (rule, value, callback) => {
      if (!validPhone(value)) {
        callback(new Error("手机号码格式不正确"))
      } else {
        accountApi.checkMobileUnique(value).then((res) => {
          if (res.code == 0) {
            callback()
          } else if (res.code == 1) {
            callback("该手机号码已经被占用")
          } else if (res.code == 301) {
            callback(new Error(res.data[0].msg))
          }
        })
      }
    }

    return {
      sendSMSed: false,
      dialogType: "",
      dialogVisible: false,
      dialogContent: "",
      captchaSrc: "",
      captchaCode: "",
      captchaCodeKey: "",
      form: {
        accountName: "",
        accountPwd: "",
        accountPwd2: "",
        userName: "",
        phone: "",
        smsCode: "",
      },

      ruleAccountName: [
        {
          required: true,
          min: 6,
          max: 20,
          message: "长度在 6 到 20 个字母/下划线/数字，第一个字母不能是下划线和数字",
          trigger: "blur",
        },
        { validator: validAccountNameFun, trigger: "blur" },
      ],

      ruleAccountPwd: [
        {
          required: true,
          min: 6,
          max: 20,
          message: "长度在 6 到 20 个字符(必须包含数字/小写字母/大写字母)",
          trigger: "blur",
        },
        { validator: validAccountPwdFun, trigger: "blur" },
      ],

      ruleAccountPwd2: [{ validator: validAccountPwd2Fun, trigger: "blur" }],

      rulePhone: [
        {
          required: true,
          trigger: "blur",
          message: "手机号码必须填写",
        },
        { validator: validPhoneFun, trigger: "blur" },
      ],
    }
  },

  created() {
    this.loadCaptcha()
  },

  methods: {
    dialogOpen(type, content) {
      this.dialogType = type
      this.dialogContent = content
      this.dialogVisible = true
    },
    dialogClose() {
      if (this.dialogType == "phone") {
        this.$refs["phone"].focus()
      } else if (this.dialogType == "captchaCode") {
        this.$refs["captchaCode"].focus()
      }
      this.dialogType = null
      this.dialogVisible = false
    },
    loadCaptcha() {
      captchaApi.image("char").then((res) => {
        if (res.code == 0) {
          this.captchaSrc = res.data.img
          this.captchaCodeKey = res.data.key
        }
      })
    },

    sendSMS() {
      if (!validPhone(this.form.phone)) {
        this.dialogOpen("phone", "请填写手机号码")
      } else if (this.captchaCode == "") {
        this.dialogOpen("captchaCode", "请填写图形验证码")
      } else {
        accountApi.sendSMSForRegister(this.form.phone, this.captchaCode, this.captchaCodeKey).then((res) => {
          if (res.code == 0 || res.code == 500) {
            this.$refs.ButtonCountDown.start()
            this.sendSMSed = true
            this.dialogOpen("", "短信验证码已经发送到手机上，请注意查看")
          } else {
            this.dialogOpen("", "发送短信失败")
          }
        })
      }
    },
    submit() {
      this.$refs.formData.validate((valid) => {
        if (valid) {
          accountApi.register(this.form.accountName, this.form.accountPwd, this.form.userName, this.form.phone, this.form.smsCode).then((res) => {
            if (res.code == 0) {
              this.$router.push("/register/success")
            } else if (res.code == 1) {
              this.dialogOpen("", res.msg)
            }
          })
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped></style>
